/*>
* @license
* Copyright (c) 2014-2022 ABILITY Network, Inc., an INOVALON, Inc. company. All Rights Reserved.
* 
* This computer program is CONFIDENTIAL and a TRADE SECRET of ABILITY Network, Inc.
* The receipt or possession of this program does not convey any rights to use,
* reproduce or disclose its contents in whole or in part, without the specific
* written consent of ABILITY Network, Inc. Any use, reproduction or disclosure of
* this program without the express written consent of ABILITY Network, Inc. is a
* violation of the copyright laws and may subject you to criminal prosecution.
<*/
export enum UserVote {
	dislike = 0,
	like = 1,
	none = 2,
}

export interface IArticle {
	contentItemId: string
	path: string
	displayText: string
	publishedUtc: Date
	markup: string
	productCode: string
	productName: string
	sectionId: string
	sectionName: string
}

export interface IArticleRating {
	contentItemId: string
	countLikes: number
	countDislikes: number
	vote: UserVote
}

export interface IContentStateManager {
	article: IArticle
	rating: IArticleRating

	voteOnArticle(contentItemId: string, userId: string, newVote: UserVote, currentVote: UserVote): Promise<IArticleRating>
	getArticle(path: string): Promise<IArticle>
	getArticleRating(contentItemId: string, userId: string): Promise<IArticleRating>
	setArticle(article: IArticle): void
	setArticleRating(rating: IArticleRating): void
	getUserId(): Promise<string>
	getProductName(productCode: string): Promise<string>
}
